/* This file is autogenerated, see readme.md for instructions */
import CheckFilledSvgIcon from '@bloomreach/banana-theme/icons/check-filled.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CheckFilledIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CheckFilledSvgIcon />
    </Icon>
  );
});

CheckFilledIcon.displayName = 'CheckFilledIcon';

export default CheckFilledIcon;
